(function () {
  'use strict';

  var FEATURE = { name: 'consent-tracking-api', version: '0.1' };
  var STORAGE_KEY = 'garaia_cookie_choice_v1';
  var POLICY_VERSION = 1;
  var CONSENT_TTL_MS = 180 * 24 * 60 * 60 * 1000;
  var CATEGORIES = ['preferences', 'analytics', 'marketing'];
  var apiReady = null;

  function normaliseChoices(value) {
    if (!value) return null;

    var choices = {};
    var isValid = CATEGORIES.every(function (category) {
      if (typeof value[category] !== 'boolean') return false;
      choices[category] = value[category];
      return true;
    });

    return isValid ? choices : null;
  }

  function readStoredChoice() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      var choices = normaliseChoices(stored && stored.choices);
      var isCurrent = stored && stored.version === POLICY_VERSION;
      var isUnexpired = stored && Number(stored.expiresAt) > Date.now();

      if (!choices || !isCurrent || !isUnexpired) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return {
        choices: choices,
        savedAt: Number(stored.savedAt),
        expiresAt: Number(stored.expiresAt)
      };
    } catch (error) {
      return null;
    }
  }

  function storeChoice(choices) {
    var normalised = normaliseChoices(choices);
    if (!normalised) return false;

    try {
      var savedAt = Date.now();
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        version: POLICY_VERSION,
        choices: normalised,
        savedAt: savedAt,
        expiresAt: savedAt + CONSENT_TTL_MS
      }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function loadPrivacyApi() {
    if (apiReady) return apiReady;

    apiReady = new Promise(function (resolve, reject) {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        reject(new Error('Shopify Customer Privacy API is unavailable.'));
        return;
      }

      window.Shopify.loadFeatures([FEATURE], function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          reject(error || new Error('Shopify Customer Privacy API failed to load.'));
          return;
        }
        resolve(window.Shopify.customerPrivacy);
      });
    });

    return apiReady;
  }

  function isComplete(consent) {
    return Boolean(consent) && CATEGORIES.every(function (category) {
      return consent[category] === 'yes' || consent[category] === 'no';
    });
  }

  function consentToChoices(consent) {
    if (!isComplete(consent)) return null;

    var choices = {};
    CATEGORIES.forEach(function (category) {
      choices[category] = consent[category] === 'yes';
    });
    return choices;
  }

  function toBoolean(value) {
    return value === 'yes';
  }

  function mount(bar) {
    if (bar.dataset.cookieMounted === '1') return;
    bar.dataset.cookieMounted = '1';

    var summary = bar.querySelector('[data-cookie-summary]');
    var preferences = bar.querySelector('[data-cookie-preferences]');
    var status = bar.querySelector('[data-cookie-status]');
    var locale = bar.dataset.locale === 'tr' ? 'tr' : 'en';
    var checkboxes = {};
    var isSaving = false;

    bar.querySelectorAll('[data-cookie-category]').forEach(function (input) {
      checkboxes[input.dataset.cookieCategory] = input;
    });

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    function setSaving(saving) {
      isSaving = saving;
      bar.querySelectorAll('.ga-cookie__button').forEach(function (button) {
        button.disabled = saving;
      });
    }

    function reveal() {
      bar.removeAttribute('hidden');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          bar.classList.add('is-visible');
        });
      });
    }

    function hide() {
      bar.classList.remove('is-visible');
      window.setTimeout(function () {
        bar.setAttribute('hidden', '');
      }, 360);
    }

    function showPreferences() {
      bar.classList.add('is-preferences');
      if (summary) summary.setAttribute('hidden', '');
      if (preferences) preferences.removeAttribute('hidden');
      reveal();
    }

    function showSummary() {
      bar.classList.remove('is-preferences');
      if (preferences) preferences.setAttribute('hidden', '');
      if (summary) summary.removeAttribute('hidden');
    }

    function syncChoices(choices) {
      Object.keys(checkboxes).forEach(function (category) {
        checkboxes[category].checked = Boolean(choices && choices[category]);
      });
    }

    function syncConsent(consent) {
      Object.keys(checkboxes).forEach(function (category) {
        checkboxes[category].checked = toBoolean(consent && consent[category]);
      });
    }

    function matchesChoices(consent, choices) {
      if (!consent) return false;
      return CATEGORIES.every(function (category) {
        return consent[category] === (choices[category] ? 'yes' : 'no');
      });
    }

    function save(choices) {
      if (isSaving) return;
      setSaving(true);
      setStatus(locale === 'tr' ? 'Seçiminiz kaydediliyor…' : 'Saving your choice…');

      // Remember the visitor's explicit choice for the banner UX even if a
      // privacy-focused browser blocks Shopify's consent API. This local value
      // never enables tracking; Shopify remains the source of truth for pixels.
      storeChoice(choices);
      hide();

      loadPrivacyApi().then(function (privacy) {
        var settled = false;
        var pollCount = 0;
        var timeoutId;
        var pollId;

        function finishSuccess() {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeoutId);
          window.clearInterval(pollId);
          setSaving(false);
          setStatus(locale === 'tr' ? 'Seçiminiz kaydedildi.' : 'Your choice has been saved.');
          hide();
        }

        function finishError() {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeoutId);
          window.clearInterval(pollId);
          setSaving(false);
          setStatus(locale === 'tr'
            ? 'Tercihiniz bu cihazda kaydedildi. Zorunlu olmayan çerezler etkinleştirilmedi.'
            : 'Your choice was saved on this device. Non-essential cookies were not enabled.');
          hide();
        }

        try {
          privacy.setTrackingConsent({
            preferences: Boolean(choices.preferences),
            analytics: Boolean(choices.analytics),
            marketing: Boolean(choices.marketing)
          }, function (result) {
            if (result && result.error) finishError();
            else finishSuccess();
          });

          if (settled) return;

          pollId = window.setInterval(function () {
            pollCount += 1;
            try {
              if (matchesChoices(privacy.currentVisitorConsent(), choices)) {
                finishSuccess();
              }
            } catch (error) {
              // The callback remains the primary completion signal.
            }
            if (pollCount >= 20) window.clearInterval(pollId);
          }, 150);

          timeoutId = window.setTimeout(function () {
            if (!settled) finishError();
          }, 4000);
        } catch (error) {
          finishError();
        }
      }).catch(function () {
        setSaving(false);
        setStatus(locale === 'tr'
          ? 'Tercihiniz bu cihazda kaydedildi. Zorunlu olmayan çerezler etkinleştirilmedi.'
          : 'Your choice was saved on this device. Non-essential cookies were not enabled.');
        hide();
      });
    }

    bar.querySelectorAll('[data-cookie-accept]').forEach(function (button) {
      button.addEventListener('click', function () {
        save({ preferences: true, analytics: true, marketing: true });
      });
    });

    bar.querySelectorAll('[data-cookie-reject]').forEach(function (button) {
      button.addEventListener('click', function () {
        save({ preferences: false, analytics: false, marketing: false });
      });
    });

    var saveButton = bar.querySelector('[data-cookie-save]');
    if (saveButton) {
      saveButton.addEventListener('click', function () {
        save({
          preferences: Boolean(checkboxes.preferences && checkboxes.preferences.checked),
          analytics: Boolean(checkboxes.analytics && checkboxes.analytics.checked),
          marketing: Boolean(checkboxes.marketing && checkboxes.marketing.checked)
        });
      });
    }

    var openButton = bar.querySelector('[data-cookie-open-preferences]');
    if (openButton) openButton.addEventListener('click', showPreferences);

    var closeButton = bar.querySelector('[data-cookie-close-preferences]');
    if (closeButton) closeButton.addEventListener('click', function () {
      if (readStoredChoice()) hide();
      else showSummary();
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cookie-preferences-trigger]');
      if (!trigger) return;
      event.preventDefault();
      setStatus('');
      var stored = readStoredChoice();
      if (stored) syncChoices(stored.choices);
      loadPrivacyApi().then(function (privacy) {
        var consent = privacy.currentVisitorConsent();
        if (isComplete(consent)) syncConsent(consent);
      }).catch(function () {});
      showPreferences();
    });

    document.addEventListener('visitorConsentCollected', function (event) {
      var choices = consentToChoices(event.detail);
      if (!choices) return;
      syncChoices(choices);
      storeChoice(choices);
    });

    // QA-only first-visit preview. It never clears or changes stored consent;
    // normal visitors never see it unless this exact query parameter is used.
    if (new URLSearchParams(window.location.search).get('ga_cookie_preview') === 'summary') {
      showSummary();
      reveal();
      return;
    }

    var stored = readStoredChoice();
    if (stored) {
      syncChoices(stored.choices);
      hide();
      return;
    }

    loadPrivacyApi().then(function (privacy) {
      var consent = privacy.currentVisitorConsent();
      var choices = consentToChoices(consent);

      if (choices) {
        syncChoices(choices);
        storeChoice(choices);
        hide();
        return;
      }

      var shouldShow = typeof privacy.shouldShowBanner !== 'function' || privacy.shouldShowBanner();
      if (shouldShow) {
        showSummary();
        reveal();
      }
    }).catch(function () {
      showSummary();
      reveal();
      setStatus(locale === 'tr'
        ? 'Çerez tercihleri yüklenemedi; zorunlu olmayan çerezler için izin verilmiş sayılmaz.'
        : 'Cookie choices could not be loaded; non-essential cookie consent is not assumed.');
    });
  }

  function init() {
    document.querySelectorAll('[data-cookie-bar]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
